<template>
   <SubLayout
        :pageTitle="title"
        :pageBreadcrumbs="breadcrumbs"
        :hasBack="true"
    >
    <template #subHeaderActions>
      
    </template>
    <template #layoutContent>   
      <EventQuizForm
        :canSubmit="$can(abilities.CAN_UPDATE_EVENT_FORM)"
        :title="defaultForm.name"
        :note="content"
        :submit-form="submitEventFormUpdate"
        :default-form="defaultForm"
        :loading="loading"
        :getting="getting"
      />  
    </template>
  </SubLayout>
  
</template>
<script setup>

import {useStore} from "vuex";
import {useRoute, useRouter} from "vue-router";
import { onMounted, ref, watch} from "vue";
import {useI18n} from "vue-i18n";
import EventQuizForm from "../../components/EventQuizForm.vue";
import SubLayout from "@/views/Layouts/partials/SubLayout.vue";
import abilities from "@/composables/abilities";

const store = useStore()
const {t} = useI18n()
const router = useRouter()
const route = useRoute()

const title = ref("") 
const breadcrumbs = ref([
  {
    name: 'events.forms.update',
    route: ''
  }
])

const loading = ref(false)
const getting = ref(false)
const defaultForm = ref([])
const content = ref('')

watch(() => route.query.tab, (value) => {
      loadEventForm()
      loadFieldTypes()
      loadFileExtensions()
    
})

const loadEventForm = async () => {
  try {
    getting.value = true;

    const [eventRes, formRes] = await Promise.all([
      store.dispatch('events/getEventDetail', route.params.id),
      store.dispatch('forms/getEventForm', route.params.form), 
    ]);

    title.value = eventRes?.data?.data?.title;
    content.value = formRes?.data?.data?.note;
    defaultForm.value = formRes?.data?.data?.form; 
  } catch (error) {
    console.error('Erreur lors du chargement du formulaire de l’événement :', error);
  } finally {
    getting.value = false;
  }
};


function submitEventFormUpdate(data, back){
  let formData = {
    id: route.params.form,
    name: data.name,
    description: defaultForm.value.description,
    act: defaultForm.value.act,
    steps: data.steps,
    note: data.note
  }
  loading.value = true
  store.dispatch('forms/saveEventForm', formData)
      .then(res => {
        window.toastr['success'](i18n.global.t("notifications.form_updated"))
        if(back){
          router.go(-1)
        }
      })
      .catch((err) => {
      })
      .finally(() => loading.value = false)
}

const loadFieldTypes = () => {
  store.dispatch('nps/getFieldTypes')
}

const loadFileExtensions = () => {
  store.dispatch('nps/getFileExtensions')
}

onMounted(() => {
    loadEventForm()
    loadFieldTypes()
    loadFileExtensions()
})

</script>
<style scoped>
.card .card-body{
  padding: 0 !important;
}

.accordion-item{
  border: 0 !important;
}
.accordion-header{
  border-radius: .625rem !important;
}

.accordion-button{
  border-radius: .625rem !important;
}
</style>